/*
  DogPure · banda visual en bucle continuo, sin controles.
  - Mueve la fila con transform (subpíxel): no se arrastra, no recibe foco y no bloquea el desplazamiento vertical.
  - Copias decorativas (aria-hidden, inert) para cubrir el ancho; el ciclo es la distancia exacta entre
    el primer original y su primera copia, así que incluye la separación entre círculos y no hay saltos.
  - Fuera de pantalla se suspende y continúa desde la misma posición.
  - Con prefers-reduced-motion se muestra estática.
*/
if (!customElements.get('dp-marquee')) {
  class DpMarquee extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-animated')) return;
      this.track = this.querySelector('[data-marquee-track]');
      this.speed = parseFloat(this.dataset.speed) || 15;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.originals = [...this.track.querySelectorAll('[data-marquee-item]')];
      this.offset = 0;
      this.visible = false;
      this.frame = this.frame.bind(this);

      new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.run();
      }).observe(this);
      new ResizeObserver(() => this.layout()).observe(this);
      this.reduce.addEventListener?.('change', () => this.layout());
      this.layout();
    }

    layout() {
      this.track.querySelectorAll('[data-marquee-clone]').forEach((c) => c.remove());
      this.track.style.transform = '';
      if (this.reduce.matches) {
        this.setAttribute('data-reduced', '');
        this.cycle = 0;
        this.run();
        return;
      }
      this.removeAttribute('data-reduced');
      // Copias hasta cubrir el ancho visible más un ciclo completo
      const needed = this.clientWidth * 2;
      let guard = 0;
      while (this.track.scrollWidth < needed + this.track.clientWidth && guard++ < 20) {
        this.originals.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.setAttribute('data-marquee-clone', '');
          clone.removeAttribute('data-marquee-item');
          // Las copias no son bloques editables: el editor de Shopify solo debe ver los originales
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('img').forEach((img) => { img.alt = ''; img.loading = 'eager'; });
          this.track.appendChild(clone);
        });
        if (this.track.scrollWidth >= needed * 2) break;
      }
      const firstClone = this.track.querySelector('[data-marquee-clone]');
      this.cycle = firstClone ? firstClone.offsetLeft - this.originals[0].offsetLeft : 0;
      if (this.cycle) this.offset %= this.cycle;
      this.apply();
      this.run();
    }

    apply() {
      this.track.style.transform = `translate3d(${-this.offset}px, 0, 0)`;
    }

    run() {
      const go = this.visible && this.cycle > 0 && !this.reduce.matches;
      if (go && !this.raf) {
        this.last = performance.now();
        this.raf = requestAnimationFrame(this.frame);
      } else if (!go && this.raf) {
        cancelAnimationFrame(this.raf);
        this.raf = null;
      }
    }

    frame(now) {
      const dt = Math.min(now - this.last, 100) / 1000;
      this.last = now;
      this.offset = (this.offset + this.speed * dt) % this.cycle;
      this.apply();
      this.raf = requestAnimationFrame(this.frame);
    }
  }
  customElements.define('dp-marquee', DpMarquee);
}
